import { IndustryCategories, PermissionsCompanyResponse } from "@lhd/types";
import { Checkbox } from "antd";
import { forwardRef } from "react";

// eslint-disable-next-line react/display-name
export default forwardRef((props: any, _ref) => {
  // const inputRef: any = useRef<HTMLInputElement>(null);
  const inputRef: any = props?.inputRef;

  const onBoxChanged = (input: any) => {
    if (input.target.value === "") {
      props.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }

    props.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged("greaterThan", input.target.value);
    });
  };

  return (
    <div className="floatingFilter-select">
      <select ref={inputRef} onInput={onBoxChanged}>
        <option value="clear">すべて</option>
        {(props?.industryCategoriesData || [])?.map((i: IndustryCategories) => (
          <option key={i?.id} value={i?.id}>
            {i?.name}
          </option>
        ))}
      </select>
    </div>
  );
});
export const columns = () => {
  return [
    {
      headerName: "",
      field: "index",
      cellRenderer: (params: any) => {
        return params.rowIndex + 1;
      },
      minWidth: 30,
      maxWidth: 30,
      filter: false,
      sortable: false,
      pinned: "left",
    },
    {
      headerName: "",
      field: "isChecked",
      minWidth: 50,
      width: 50,
      pinned: "left",
      cellStyle: { textAlign: "center", justifyContent: "start" },
      filter: false,
      sortable: false,
    },
    {
      headerName: "会社名",
      field: "name",
      minWidth: 360,
    },
    {
      headerName: "ステーションID",
      field: "station_id",
      minWidth: 150,
    },
    {
      headerName: "法人番号",
      field: "co_number",
      minWidth: 120,
    },
    {
      headerName: "代表者名",
      field: "ceo_name",
      minWidth: 120,
    },
    {
      headerName: "郵便番号",
      field: "zipcode",
      minWidth: 90,
    },
    {
      headerName: "住所",
      field: "address",
      minWidth: 120,
    },
    {
      headerName: "業種選択",
      field: "industry_category.name",
      minWidth: 220,
    },
    {
      headerName: "管理",
      field: "is_admin",
      maxWidth: 100,
      minWidth: 75,

      cellRenderer: (e: any) => {
        return (
          <Checkbox
            disabled
            className="cell-checkbox"
            defaultChecked={e.value}
          />
        );
      },
    },
  ];
};

export const FILTER_PARAMS = {
  name: "q[name_cont]",
  station_id: "q[station_id_cont]",
  co_number: "q[co_number_cont]",
  ceo_name: "q[ceo_name_cont]",
  zipcode: "q[zipcode_cont]",
  address: "q[address_cont]",
  is_admin: "q[is_admin_eq]",
  "industry_category.name": "q[industry_category_id_eq]",
};

export const convertPermissionToTabs = (
  permissions?: PermissionsCompanyResponse,
) => {
  const { company_view, company_edit, company_delete } = permissions ?? {};

  const data: any = {
    [COMPANY_DETAIL_TABS.REGISTRATION_INFO.key]: null,
    [COMPANY_DETAIL_TABS.INVESTOR_HISTORIES.key]: null,
    [COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key]: null,
    [COMPANY_DETAIL_TABS.EMPLOYMENT_CONTRACTS.key]: null,
    [COMPANY_DETAIL_TABS.CONTRACT.key]: null,
    [COMPANY_DETAIL_TABS.LABOR_DOCUMENTS.key]: null,
    [COMPANY_DETAIL_TABS.FINANCIAL_REPORTS.key]: null,
  };

  const permissionTypes = [
    { perms: company_view, level: "view" },
    { perms: company_edit, level: "edit" },
    { perms: company_delete, level: "delete" },
  ];

  permissionTypes.forEach(({ perms, level }) => {
    if (perms) {
      if (perms.includes("all")) {
        Object.keys(data).forEach((key) => {
          data[key] = level;
        });
      } else {
        perms.forEach((perm: string) => {
          data[perm] = level;
        });
      }
    }
  });

  return data;
};

export const buttonWithPermission = {
  view: {
    edit: true,
    addUp: true,
    addDown: true,
    delete: true,
  },
  edit: {
    edit: false,
    addUp: true,
    addDown: true,
    delete: true,
  },
  delete: {
    edit: false,
    addUp: false,
    addDown: false,
    delete: false,
  },
};
export const COMPANY_DETAIL_TABS = {
  REGISTRATION_INFO: { key: "registration_information", label: "登記情報" },
  CONTRACT: { key: "agreements", label: "契約書/誓約書" },
  GENERAL_MANAGEMENT_INFO: {
    key: "general_management_information",
    label: "総務管理情報",
  },
  EMPLOYMENT_CONTRACTS: {
    key: "employment_contracts",
    label: " 雇用契約書",
  },
  EMPLOYEE_RULES: { key: "employment_rules", label: "就業規則/規程" },
  FINANCIAL_REPORTS: {
    key: "financial_reports",
    label: "決算報告書",
  },
  WORKER_LIST: { key: "worker_list", label: "社員一覧" },
  INVESTOR_HISTORIES: { key: "investor_histories", label: "株主/出資者情報" },
  LABOR_DOCUMENTS: { key: "labor_documents", label: "労務文書保管" },
};

export const tabOrder = [
  COMPANY_DETAIL_TABS.REGISTRATION_INFO.key,
  COMPANY_DETAIL_TABS.INVESTOR_HISTORIES.key,
  COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key,
  COMPANY_DETAIL_TABS.EMPLOYMENT_CONTRACTS.key,
  COMPANY_DETAIL_TABS.CONTRACT.key,
  COMPANY_DETAIL_TABS.LABOR_DOCUMENTS.key,
  COMPANY_DETAIL_TABS.FINANCIAL_REPORTS.key,
];

export const tabShowScrollbar = [
  COMPANY_DETAIL_TABS.REGISTRATION_INFO.key,
  COMPANY_DETAIL_TABS.INVESTOR_HISTORIES.key,
  COMPANY_DETAIL_TABS.GENERAL_MANAGEMENT_INFO.key,
];

export const permissionConvert = {
  view: {
    create: false,
    delete: false,
    edit: false,
    view: true,
  },
  edit: {
    create: false,
    delete: false,
    edit: true,
    view: true,
  },
  delete: {
    create: true,
    delete: true,
    edit: true,
    view: true,
  },
};
